import type { IconData } from '@stacksjs/iconify-core'

export const logoLinkedin: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.47 3.05H32v25.9h-1.53Zm-1.52 25.9h1.52v1.53h-1.52Zm0-27.43h1.52v1.53h-1.52Zm-1.53 3.05h1.53v22.86h-1.53ZM3.04 30.48h25.91V32H3.04Zm1.53-3.05h22.85v1.52H4.57Zm18.28-12.19h-1.52v-1.53h-3.05v1.53h-1.52v-1.53h-3.05v9.15h3.05v-4.57h1.52v-1.53h1.53v1.53h1.52v4.57h3.05v-6.1h-1.53zM7.61 13.71h3.05v9.15H7.61Zm0-4.57h3.05v3.05H7.61ZM4.57 3.05h22.85v1.52H4.57ZM3.04 0h25.91v1.52H3.04Zm0 4.57h1.53v22.86H3.04ZM1.52 28.95h1.52v1.53H1.52Zm0-27.43h1.52v1.53H1.52ZM0 3.05h1.52v25.9H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default logoLinkedin
